"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPLOADCARE_IMAGE_SIZE_LIMIT = exports.UPLOADCARE_FILE_DATA_KEY = exports.UPLOADCARE_CDN_URL = void 0;
var UPLOADCARE_CDN_URL = exports.UPLOADCARE_CDN_URL = 'https://cdn.uc.assets.prezly.com';
var UPLOADCARE_FILE_DATA_KEY = exports.UPLOADCARE_FILE_DATA_KEY = 'prezly:data';
var UPLOADCARE_IMAGE_SIZE_LIMIT = exports.UPLOADCARE_IMAGE_SIZE_LIMIT = 78643200;